'use strict';

module.exports = {
  CONTROL_ID: "controlID",
  CONTROL_TYPE_ID: "controlTypeID",
  IS_SHOW: "isShow",
  CAPTION: "caption",
  X: "x",
  Y: "y",
  W: "w",
  H: "h",
  MEASURED_WIDTH: "measuredW",
  MEASURED_HEIGHT: "measuredH",
  Z_ORDER: "zOrder",
  LOCKED: "locked",
  SIZE_LOCKED: "sizeLocked",
  COLOR: "color",
  BORDER_VISIBLE: "borderVisible",
  BORDER_COLOR: "borderColor",
  IS_AUTO_SIZE: "isAutoSize",
  STATUS: "status",
  OPACITY: "opacity",
  IS_COMMENT_COM: "isCommentCom",
  CAN_MOVE: "canMove",
  ALIAS: "alias",
  ROTATION: "rotation",
  VERTICAL_SCROLL_BAR_SHOW: "verticalScrollbarShow",
  CHAR_DATA: "CharData",
  VERTICAL_SCROLL_BAR_PROGRESS: "verticalScrollbarProgress",
  HORIZONTAL_SCROLL_BAR_SHOW: "horizontalScrollbarShow",
  HORIZONTAL_SCROLL_BAR_PROGRESS: "horizontalScrollbarProgress",
  TEXT_COLOR: "textColor",
  TEXT_SIZE: "textSize",
  TEXT_FONT_FAMILY: "textFontFamily",
  LINE_SPACING_MULTIPLE: "lineSpacingMultiple",
  LINE_SPACING:'lineSpacing',
  TEXT_ALIGN: "textAlign",
  TEXT_V_ALIGN: "textVAlign",
  TEXT_WORDWRAP: "textWordWrap",
  TEXT_STYLES: "textStyles",
  SELECTED_INDEX: "selectedIndex",
  SELECTED_COLOR: "selectedColor",
  TEXT_PADDING: "textPadding",
  SHAPE_BORDER_TYPE: "shapeBorderType",
  TRIANGLE_TYPE: "triangleType",
  DASH_MODE: "dashMode",
  RECTANGLE_BORDER_LEFT_VISIBLE: "rectangleBorderLeftVisible",
  RECTANGLE_BORDER_RIGHT_VISIBLE: "rectangleBorderRightVisible",
  RECTANGLE_BORDER_TOP_VISIBLE: "rectangleBorderTopVisible",
  RECTANGLE_BORDER_BOTTOM_VISIBLE: "rectangleBorderBottomVisible",
  RADIUS: "radius",
  RADIUS_IS_PERCENT: "radiusIsPercent",
  THICKNESS: "thickness",
  TEXT: "text",
  BUTTON_STATUS: "buttonStatus",
  IS_AUTO_TEXT_COLOR: "IsAutoTextColor",
  ROTATION_ANGLE: "rotationAngle",
  ICON: "icon",
  ID: "ID",
  ICON_FONT_NAME: "iconFontName",
  ICON_CODE: "iconCode",
  URL: "URL",
  FLIP_HORIZONTAL: "FlipHorizontal",
  FLIP_VERTICAL: "FlipVertical",
  CLIP_SHAPE_TYPE: "clipShapeType",
  FILTER_TYPE: "filterType",
  FILTER_PENCIL_VALUE: "filterPencilValue",
  FILTER_SKETCH_VALUE: "filterSketchValue",
  FIT_MODE: "fitMode",
  CAN_INPUT: "canInput",
  CONTROL_POINT: "controlPoint",
  START_POINT: "startPoint",
  END_POINT: "endPoint",
  TEXT_BACKGROUND_COLOR: "textBackgroundColor",
  TEXT_BORDER_COLOR: "textBorderColor",
  SHOW_START_ARROW: "showStartArrow",
  SHOW_END_ARROW: "showEndArrow",
  IS_CURVED: "isCurved",
  IS_TEXT_POS_CENTER: "isTextPosCenter",
  ANI_TYPE: "aniType",
  PLAY_INTERVAL: "playInterval",
  IS_AUTO_PLAY: "isAutoPlay",
  INDICATOR_DIRECTION: "indicatorDirection",
  INDICATOR_TYPE: "indicatorType",
  INDICATOR_COLOR: "indicatorColor",
  IS_SHOW_INDICATOR: "isShowIndicator",
  CONTENT_LAYOUT: "contentLayout",
  CAN_HORI_SCROLL: "canHoriScroll",
  CAN_VERT_SCROLL: "canVertScroll",
  SHOW_SCROLL_BARS: "showScrollBars",
  //THINKNESS: "thinkness",
  STATE: "state",
  TEXT_DIRECTION: "textDirection",
  GAP: "gap",
  SIZE: "size",
  ROW_GAP: "rowGap",
  COLUMN_GAP: "columnGap",
  ITEM_HEIGHT: "itemHeight",
  COLUMN_COUNT: "columnCount",
  IS_INTERLACE: "isInterlace",
  INTERLACE_COLOR: "interlaceColor",
  SHOW_H_LINE : "showHLine",
  SHOW_H_LINE2: "ShowHLine",
  ROW_COUNT: "rowCount",
  BASE_HEIGHT: "baseHeight",
  SHOW_HOVER: "showHover",
  HOVERED_COLOR: "hoveredColor",
  SELECTED_TEXT_COLOR: "selectedTextColor",
  TIP_CORNER_DIRECTION: "tipCornerDirection",
  STYLE: "style",
  ICON_SIZE: "iconSize",
  SHOW_TEXT: "showText",
  SHOW_ALARM: "showAlarm",
  ALARM_COLOR: "AlarmColor",
  ALARM_TEXT: "AlarmText",
  PROGRESS: "progress",
  BAR_STYLE: "barStyle",
  TRACK_COLOR: "trackColor",
  VALUE: "value",
  SELECTION: "selection",
  BORDER_STYLE: "borderStyle",
  SHOW_V_LINE: "showVLine",
  SHOW_V_LINE2 : 'ShowVLine',
  SHOW_HEADER: "showHeader",
  DIRECTION: "direction",
  TAB_HEIGHT: "tabHeight",
  TAB_POSITION: "tabPosition",
  SHOW_MIN: "showMin",
  SHOW_MAX: "showMax",
  SHOW_CLOSE: "showClose",
  SHOW_DRAG: "showDrag",
  TOP_HEIGHT: "topHeight",
  BOTTOM_HEIGHT: "bottomHeight",
  PHONE_TYPE: "phoneType",
  IS_TRANSPARENT: "isTransparent",
  FULL_SCREEN: "fullScreen",
  SHOW_ICON: "showIcon",
  INDICATOR_PERCENT_WIDTH: "indicatorPercentWidth",
  INDICATOR_HEIGHT: "indicatorHeight",
  DIVIDER_PERCENT_HEIGHT: "dividerPercentHeight",
  DIVIDER_COLOR: "dividerColor",
  IS_OPEN: "isOpen",
  OPEN_COLOR : 'onColor',
  CLOSE_COLOR : 'offColor',
  BACKGROUND_COLOR : 'color',
  SHOW_MENU: "showMenu",
  SHOW_BACK: "showBack",
  ICON_COLOR: "iconColor",
  FOREGROUND_COLOR: "ForegroundColor",
  KEYBOARD_TYPE: "keyboardType",
  FILTER: "filter",
  IS_SHOW_TAB_BAR: "isShowTabBar",
  STROKE_THICKNESS: "strokeThickness",
  POINT_LIST: "pointList",
  MULTI_LINE_TEXT : 'multilineText',
  SHOW_SEPARATOR : 'showSeparator',
  SEPARATOR_COLOR : 'separatorColor',
  ICON_STYLE : 'iconStyle',
  TAB_STYLE:'tabStyle',
  TAB_COLOR : 'tabColor',
  TAB_EDGE : 'tabEdge',
  TAB_DIRECTION : 'tabDirection',
  ON_COLOR : 'onColor',
  OFF_COLOR : 'offColor',
  COLUMN_RATIO : 'columnRatio'
};


// WEBPACK FOOTER //
// ./src/constants/propConst.js